import { useCallback, useEffect, useState } from "react";
import styled from "styled-components";
import { ReactComponent as CloseIcon } from "../../../../../assets/icons/x-close.svg";
import * as Library from "../../../../../utils/Library";
import FormContainer from "../../../../common/forms/FormContainer";
import SimpleListComponent from "../../../../common/lists/SimpleListComponent";
import FullScreenLoader from "../../../../common/loaders/FullScreenLoader";

// #region SCOPED CSS
const StyledSourcePreview = styled.div`
    &.source-preview-container {
        color: var(--text-icons-gray-100);
        margin: 16px;
        width: 72vw;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        position: relative;
    }

    .source-preview-content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        flex: 1;
        overflow: hidden;
        position: relative;
    }

    .source-preview-table {
        display: flex !important;
        flex-direction: column;
        flex-shrink: 1;
        overflow: auto !important;
    }
`;
// #endregion

export default function POSSourcePreview({ show, labelBrandID, onCloseClick }) {
    // #region VARS
    const [isLoading, setIsLoading] = useState(false);
    const [items, setItems] = useState([]);

    const columns = [
        {
            name: "Name",
            selector: row => row.name ?? "--",
            sortable: true,
            width: "130px"
        },
        {
            name: "Reference code",
            selector: row => row.referenceCode ?? "--",
            width: "125px"
        },
        {
            name: "Season",
            selector: row => row.season ?? "--",
            width: "150px"
        },
        {
            name: "Gender",
            selector: row => row?.gender ?? "--",
            width: "150px"
        },
        {
            name: "Product type",
            selector: row => row?.productType ?? "--",
            width: "110px"
        },
        {
            name: "Category",
            selector: row => row?.category ?? "--",
            width: "130px"
        },
        {
            name: "Barcode",
            selector: row => row.barcode ?? "--",
            width: "130px"
        },
        {
            name: "Size",
            selector: row => row.size ?? "--",
            width: "130px"
        },
        {
            name: "Color",
            selector: row => row.colorName ?? "--",
            width: "130px"
        }
    ];
    // #endregion

    // #region METHODS
    const fetchData = useCallback(async () => {
        if (!labelBrandID) return;

        const res = await Library.makeApiRequest({
            endpoint: "Products/getProductsExcelData",
            data: { labelBrandID },
            setLoader: setIsLoading
        });

        if (res?.data?.status !== 200) return;
        const data = res.data?.data?.result || res.data?.data || [];

        setItems(Array.isArray(data) ? data : []);
    }, [labelBrandID]);
    // #endregion

    // #region EFFECTS
    useEffect(() => {
        if (show) fetchData();
    }, [fetchData, show]);
    // #endregion

    // #region RENDER
    return (
        <>
            <FullScreenLoader isLoading={isLoading} isLoadingOverlay={true} />

            <StyledSourcePreview className="source-preview-container">
                <FormContainer
                    title="SOURCE FILE PREVIEW"
                    rightComponent={
                        <div className="cursor-pointer" onClick={onCloseClick}>
                            <CloseIcon />
                        </div>
                    }>
                    <div className="source-preview-content">
                        <SimpleListComponent
                            className="source-preview-table w-100"
                            tableClassName="source-preview-list w-100"
                            fixedHeaderScrollHeight="calc(65vh - 160px)"
                            columns={columns}
                            listData={items}
                            selectableRows={false}
                            pagination={false}
                            showHeader={false}
                            enabled={true}
                        />
                    </div>
                </FormContainer>
            </StyledSourcePreview>
        </>
    );
    // #endregion
}
